import { Outlet, Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LayoutDashboard, Search, Shield, LogOut, Database } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Layout() {
  const { user, logout } = useAuth();
  const location = useLocation();

  const navItems = [
    { to: "/", label: "Dashboard", icon: LayoutDashboard },
    { to: "/product-inquiry", label: "Product Inquiry", icon: Search },
  ];

  if (user?.role === "admin") {
    navItems.push({ to: "/admin", label: "Admin", icon: Shield });
  }

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A]" data-testid="app-layout">
      <header
        className="bg-[#0A0A0A]/80 backdrop-blur-xl border-b border-[#262626] sticky top-0 z-50"
        data-testid="app-header"
      >
        <div className="max-w-[1600px] mx-auto px-4 md:px-8 h-14 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <Link to="/" className="flex items-center gap-2">
              <Database size={20} className="text-[#0066FF]" />
              <span
                className="text-lg font-bold text-white"
                style={{ fontFamily: "Chivo, sans-serif" }}
              >
                ReportHub
              </span>
            </Link>
            <nav className="flex items-center gap-1" data-testid="main-nav">
              {navItems.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition-colors duration-150 ${
                    isActive(item.to)
                      ? "bg-[#1E1E1E] text-white"
                      : "text-[#A3A3A3] hover:text-white hover:bg-[#1E1E1E]"
                  }`}
                >
                  <item.icon size={16} />
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-sm text-[#A3A3A3]" data-testid="user-email">
              {user?.email}
            </span>
            <span className="text-xs px-2 py-0.5 rounded bg-[#1E1E1E] text-[#A3A3A3] uppercase tracking-wider">
              {user?.role}
            </span>
            <Button
              variant="ghost"
              size="sm"
              onClick={logout}
              className="text-[#A3A3A3] hover:text-white hover:bg-[#1E1E1E]"
              data-testid="logout-button"
            >
              <LogOut size={16} />
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-[1600px] mx-auto p-4 md:p-8">
        <Outlet />
      </main>
    </div>
  );
}
